<ng-container *transloco="let t; read: 'user'">
<div class="pl-5">
  <div class="flex justify-between items-center">
    <h1 class="text-2xl pb-3"> {{ isFutureEvidence ? t('dashboard.portfolio.reviewEvidence.titleLibrary') : t('dashboard.portfolio.reviewEvidence.title') }}</h1>
    @if (!isFutureEvidence) {
      <drdp-btn color="outline" (click)="onDownloadPdf()" type="button">
        <i class="text-drdpblue-300 text-xl uil uil-print"></i>
        {{ t('dashboard.portfolio.reviewEvidence.printExisting') }}
      </drdp-btn>
    }
  </div>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
    <div>
      @if (!isFutureEvidence) {
        <p class="global-font-bold">{{ t('dashboard.portfolio.ratingPeriodLabel') }}
          <span class="global-font-normal">
            {{ classDetails?.ratingPeriodName }}
          </span>
        </p>
      }
      @if (!isFutureEvidence) {
        <p class="global-font-bold">{{ t('dashboard.portfolio.addEvidence.classroomLabel') }} <span class="global-font-normal">{{classDetails?.classroomName}}</span></p>
        <p class="global-font-bold">{{ t('dashboard.portfolio.addEvidence.ageGroupInstrumentLabel') }} <span class="global-font-normal">{{ageGroupInstrumentName}}</span></p>
      }
      <p class="global-font-bold">{{ t('dashboard.portfolio.addEvidence.childrenLabel') }} <span class="global-font-normal">{{studentDetails?.firstName! + ' ' +
      studentDetails?.lastName!}}</span></p>
    </div>
    @if (!isFutureEvidence) {
      <div class="text-right mt-3">
        <drdp-btn color="outline" (click)="addToMessageBoard()" type="button">
          <i class="text-drdpblue-300 text-xl uil uil-envelope"></i>
        {{ t('dashboard.portfolio.reviewEvidence.addToMessageBoard') }}</drdp-btn>
      </div>
    }
  </div>
</div>

<div class="pl-5 my-5 flex flex-row justify-between gap-3">
  <div class="flex gap-3">
    <drdp-btn [color]="domainBg" type="button" (click)="handleDomain()">{{ t('dashboard.portfolio.reviewEvidence.domains') }}</drdp-btn>
    <drdp-btn [color]="measuresBg" type="button" (click)="handleMeasures()">{{ t('dashboard.portfolio.reviewEvidence.measures') }}</drdp-btn>
  </div>
  <a class="self-center text-sm order-last cursor-pointer" (click)="goBack()"><i
  class="uil uil-angle-left-b text-base"></i>{{ t('dashboard.portfolio.reviewEvidence.backToChildren') }}</a>
</div>

@if (showDomain) {
  <div>
    @if (!isFutureEvidence) {
      <ng-continer>
        @for (domain of measures; track domain) {
          <div class="py-4">
            <ng-container *ngTemplateOutlet="sharedDomainsContent; context: {$implicit: domain}"></ng-container>
          </div>
        }
      </ng-continer>
    } @else if (isUserState2025Enforced) {
      <h2 class="font-bold pt-3 pb-1">DRDP 2025</h2>
      @for (domain of measures; track domain) {
        @if (domain.is2025) {
          <div class="py-4">
            <ng-container *ngTemplateOutlet="sharedDomainsContent; context: {$implicit: domain}"></ng-container>
          </div>
        }
      }
    } @else {
      <h2 class="font-bold pt-3 pb-1">{{ t('dashboard.portfolio.addEvidence.drdp2015') }}</h2>
      @for (domain of measures; track domain) {
        @if (!domain.onlyPilot && !domain.is2025) {
          <div class="py-4">
            <ng-container *ngTemplateOutlet="sharedDomainsContent; context: {$implicit: domain}"></ng-container>
          </div>
        }
      }
      <h2 class="font-bold pt-6 pb-2">{{ t('dashboard.portfolio.addEvidence.drdp2025') }}</h2>
      @for (domain of measures; track domain) {
        @if (domain.is2025) {
          <div class="py-4">
            <ng-container *ngTemplateOutlet="sharedDomainsContent; context: {$implicit: domain}"></ng-container>
          </div>
        }
      }
    }
    <ng-template #sharedDomainsContent let-domain>
      <div class=" rounded-3xl bg-white p-3 drop-shadow-md">
        <div class="flex justify-between items-center cursor-pointer" (click)="changeDomainShow(domain)">
          <div class="flex">
            <div class=" pl-1.5">
              <p class="text-lg font-semibold">{{domain?.domainCode}}</p>
            </div>
          <i [class]="show && selectedDomain?.domainCode === domain.domainCode && selectedDomain?.is2025 === domain.is2025 
            ? 'uil uil-angle-right text-xl' : 'uil uil-angle-down text-xl'">
            </i>
          </div>
          <p class="text-sm justify-self-end">{{getEvidenceCount(domain, measureType.Domain)}}</p>
        </div>
        @if (show && selectedDomain?.domainCode === domain.domainCode && selectedDomain?.is2025 === domain.is2025) {
          <div class="flex flex-col">
            <div class=" relative">
              <drdp-portfolio-evidence-management [domainId]="domain.id" [domainGroupings]="measures" [isFutureEvidence]="isFutureEvidence"
                [evidences]="domainEvidence" [isDomain]="true" [isPortfolio]="true" (refreshEvidences)="updateEvidence()" [availableClasses]="studentActiveEnrollments"
                [assignmentPayload]="assignmentPayload" [hasStructuredPrompt]="domain.isStructuredPrompt" [is2025Domain]="domain.is2025">
              </drdp-portfolio-evidence-management>
            </div>
          </div>
        }
      </div>
    </ng-template>
  </div>
}

@if (!showDomain) {
  <div>
    @if (!isFutureEvidence) {
      @for (domain of measures; track domain) {
        <div class="py-4">
          <ng-container *ngTemplateOutlet="sharedDomainsMeasuresContent; context: {$implicit: domain}"></ng-container>
        </div>
      }
    } @else if (isUserState2025Enforced) {
      <h2 class="font-bold pt-3 pb-1">DRDP 2025</h2>
      @for (domain of measures; track domain) {
        @if (domain.is2025) {
          <div class="py-4">
            <ng-container *ngTemplateOutlet="sharedDomainsMeasuresContent; context: {$implicit: domain}"></ng-container>
          </div>
        }
      }
    } @else {
      <h2 class="font-bold pt-3">{{ t('dashboard.portfolio.addEvidence.drdp2015') }}</h2>
      @for (domain of measures; track domain) {
        @if (!domain.onlyPilot && !domain.is2025) {
          <div class="py-4">
            <ng-container *ngTemplateOutlet="sharedDomainsMeasuresContent; context: {$implicit: domain}"></ng-container>
          </div>
        }
      }
      <h2 class="font-bold pt-4 pb-1">{{ t('dashboard.portfolio.addEvidence.drdp2025') }}</h2>
      @for (domain of measures; track domain) {
        @if (domain.is2025) {
          <div class="py-4">
            <ng-container *ngTemplateOutlet="sharedDomainsMeasuresContent; context: {$implicit: domain}"></ng-container>
          </div>
        }
      }
    }
    <ng-template #sharedDomainsMeasuresContent let-domain>
      <div class="flex items-center">
        <img [src]="'assets/images/domains/' + get2025DomainIcon(domain.domainCode, domain.iconName, domain.is2025)" [alt]="domain.domainCode" class="mr-2 w-8 h-8">
        <h1 class="global-font-bold">{{ domain.domainCode }}</h1>
      </div>
      @for (measure of domain.measures; track measure) {
        <div class="py-4">
          <div class=" rounded-3xl bg-white p-3 drop-shadow-md">
            <div class="flex justify-between items-center cursor-pointer" (click)="changeMeasureShow(measure)">
              <div class="flex">
                <div class=" pl-1.5">
                  <p class="text-lg font-semibold">{{measure.code}}</p>
                </div>
            <i [class]="show && selectedMeasure?.code === measure.code && selectedMeasure?.is2025 === measure.is2025 
              ? 'uil uil-angle-right text-xl' : 'uil uil-angle-down text-xl'">
                </i>
              </div>
              <div class="flex flex-col w-44">
                <p class="text-sm justify-self-end">{{getEvidenceCount(measure, measureType.Measure)}}</p>
                @for (measureRating of measurePrelimRatings; track measureRating) {
                  <div class="flex items-center">
                    @if (measureRating.selectedLevel && measure.id === measureRating.measureId) {
                      <div
                        class="flex items-center">
                        <label class="font-normal text-sm">{{measureRating.levelName}}</label>
                        <img class="w-5 h-5 ml-2 -mt-1"
                          src="assets/images/portfolio/{{measureRating.levelIcon}}-{{measureRating.selectedLevel ? measureRating.selectedLevel: 1}}.svg" />
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
            @if (show && selectedMeasure?.code === measure.code && selectedMeasure?.is2025 === measure.is2025) {
              <div class="flex flex-col">
                <div class=" relative">
                  <drdp-portfolio-evidence-management [measureId]="measure.id" [domainGroupings]="measures" [isFutureEvidence]="isFutureEvidence"
                    [evidences]="measureEvidence" [ageGradeId]="ageGradeId" [isDomain]="false" [isPortfolio]="true" [is2025Measure]="measure.is2025"
                    [description]="measure.description" (prelimRatingChange)="updateEvidencePrelimRating($event)" (refreshEvidences)="updateEvidence()" [availableClasses]="studentActiveEnrollments"
                    [assignmentPayload]="assignmentPayload" [hasStructuredPrompt]="measure.isStructuredPrompt">
                  </drdp-portfolio-evidence-management>
                </div>
              </div>
            }
          </div>
        </div>
      }
    </ng-template>
  </div>
}
</ng-container>
